import { type HTMLAttributes, forwardRef } from 'react'
import { cn } from '../../lib/utils'

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  hover?: boolean
  glass?: boolean
}

const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ hover = false, glass = false, className, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'rounded-md border',
          glass
            ? 'bg-surface-card/60 backdrop-blur-md border-surface-border/25 dark:border-white/5'
            : 'bg-surface-card border-surface-elevated/40',
          // 그림자 절제 — 카드는 평면 + 보더로 분리, 그림자는 아주 작게만
          hover && 'transition-colors duration-200 hover:border-brand-primary/30',
          className,
        )}
        {...props}
      >
        {children}
      </div>
    )
  },
)
Card.displayName = 'Card'

export const CardHeader = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('px-6 pt-6 pb-0', className)} {...props} />
)

export const CardBody = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('p-6', className)} {...props} />
)

export const CardFooter = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('px-6 pb-6 pt-0', className)} {...props} />
)

export default Card
